import axios from '@/plugins/axios'

const state = {
  blobSuggestionTags: []
}

// getters
const getters = {
  blobSuggestionTags(state) {
    return state.blobSuggestionTags
  },
}

// actions
const actions = {

  async loadBlobSuggestionTags({ commit }) {
    commit('addToLoadingQueue', 'load_tags_blob_suggestion',  { root: true });

    return axios.get('/tags/blob-suggestion')
      .then((response) => {
        commit('setBlobSuggestionTags', response.data);
        commit('removeFromLoadingQueue', 'load_tags_blob_suggestion',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'load_tags_blob_suggestion',  { root: true });
        commit('error/newError', {
          title: 'error.tags.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  }
}

// mutations
const mutations = {
  setBlobSuggestionTags(state, tags) {
    state.blobSuggestionTags = tags
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
